import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31787d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-header" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "heading-secondary heading-secondary__primary" }
const _hoisted_4 = { class: "description" }

import useLocale from '@/hooks/useLocale' // 国际化hook
import { useRouter } from 'vue-router';
import { computed } from '@vue/reactivity';
import { useStore} from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'SideHeader',
  setup(__props) {

const store = useStore();
const router = useRouter()
const lang = computed(() => store.getters.lang);
const {
  i18n: { t }, // 解构实例用具t 访问语言变量
} = useLocale()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _renderSlot(_ctx.$slots, "heading-primary")
    ]),
    _createElementVNode("h3", _hoisted_3, [
      _renderSlot(_ctx.$slots, "heading-secondary")
    ]),
    _createElementVNode("h3", {
      class: _normalizeClass(["heading-tertiary", {'margin__en': _unref(lang)==='en'}])
    }, [
      _renderSlot(_ctx.$slots, "heading-secondary2")
    ], 2),
    _createElementVNode("p", _hoisted_4, [
      _renderSlot(_ctx.$slots, "description")
    ]),
    _createElementVNode("a", {
      class: "u-btn btn",
      style: {"margin-top":"4rem"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/freetrial')))
    }, _toDisplayString(_unref(t)('btn.btnTrail')), 1)
  ]))
}
}

})